import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ModalWindow, Text, TextArea, useLocalizeMessage, useToastNotification } from 'libs.nucleus';
// Matches the backend `ec__cancellation_reason` string validator (min 0, max 250) on
// ec__signed_document — see econsent-enviroment/configuration/env/objects/ec__signed_document.json.
const VOID_REASON_MAX_LENGTH = 250;
export const VoidDocumentModal = ({ document, isOpen, onClose, onVoided, apiClient, getApiErrorMessage, }) => {
    const translate = useLocalizeMessage();
    const { addNotification } = useToastNotification();
    const [reason, setReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [hasReasonBeenTouched, setHasReasonBeenTouched] = useState(false);
    useEffect(() => {
        if (!isOpen) {
            setReason('');
            setIsSubmitting(false);
            setHasReasonBeenTouched(false);
        }
    }, [isOpen]);
    const trimmedReason = reason.trim();
    const showReasonRequiredError = hasReasonBeenTouched && !trimmedReason;
    const handleReasonChange = (event) => {
        setReason(event.target.value.slice(0, VOID_REASON_MAX_LENGTH));
        setHasReasonBeenTouched(true);
    };
    const handleVoid = async () => {
        if (!document || !trimmedReason) {
            setHasReasonBeenTouched(true);
            return;
        }
        setIsSubmitting(true);
        try {
            await apiClient.post('/routes/econsent/void_document', {
                ec__signed_document: document._id,
                reason: trimmedReason,
            });
            addNotification({
                title: '',
                subtitle: translate('info.participant_documents.void_success'),
                type: 'success',
            });
            onVoided();
            onClose();
        }
        catch (error) {
            addNotification({
                title: '',
                subtitle: getApiErrorMessage?.(error, true) ?? translate('error.participant_documents.void_failed'),
                type: 'error',
            });
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return (_jsx(ModalWindow, { title: translate('label.participant_documents.void_document'), isOpen: isOpen, closeWindow: onClose, width: 'base', dataTestId: 'void-document-modal', footerSecondaryActionButtons: [{ label: translate('generic.cancel'), onClick: onClose, disabled: isSubmitting }], footerPrimaryActionButton: {
            label: isSubmitting
                ? translate('action.participant_documents.voiding')
                : translate('action.participant_documents.void_consent'),
            onClick: handleVoid,
            variant: 'primary',
            disabled: !trimmedReason || isSubmitting,
        }, children: _jsxs("div", { className: 'flex flex-col gap-4 py-2', children: [_jsx(Text, { className: 'text-neutral-600', children: translate('info.participant_documents.void_confirmation') }), _jsx(TextArea, { id: 'void-document-reason', label: translate('label.participant_documents.void_reason'), value: reason, onChange: handleReasonChange, onBlur: () => setHasReasonBeenTouched(true), maxLength: VOID_REASON_MAX_LENGTH, disabled: isSubmitting, required: true, hasError: showReasonRequiredError, errorMessage: showReasonRequiredError ? translate('error.participant_documents.void_reason_required') : undefined, width: 'full', dataTestId: 'void-document-reason-input' })] }) }));
};
